export default () => ({
  accessToken: localStorage.getItem("accessToken") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
  roles: localStorage.getItem("roles") || null,
  authenticated: false,
  user: null,
});
